'use strict';

var ReviewInputDataChartLegendDirective = function ReviewInputDataChartLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/review-input-data-chart-legend.html'),
    controller: 'ReviewInputDataChartLegendController',
    scope: {
      markets: '=',
      level: '=',
      legend: '='
    }
  };
};
ReviewInputDataChartLegendDirective.$inject = [];
module.exports = ReviewInputDataChartLegendDirective;